export const paddingCardsTables = 9;

export const timeToClosedToast = 12000;

export const mtDividerCardUSer = 2;

export const mtDividerUpTable = 2;

export const showNumberRowsTable = 10;
